/**
 * Soft confidence UX — guess vs confirmed tags (no raw % in the UI).
 */

const GUESS_SOURCES = new Set(['fuzzy', 'amount_heuristic', 'registry_weak']);

/** Auto-tagged but not rock-solid — invite user to confirm */
export function isGuessTxn(txn) {
    if (!txn) return false;
    const src = txn.category_source;
    if (src === 'user' || src === 'manual') return false;
    const cat = txn.category || 'Uncategorized';
    if (cat === 'Uncategorized') return false;
    if (GUESS_SOURCES.has(src)) return true;
    const conf = Number(txn.confidence);
    if (Number.isFinite(conf) && conf > 0 && conf < 0.85) return true;
    return false;
}

export function isUncategorizedTxn(txn) {
    if (!txn) return true;
    const cat = txn.category || 'Uncategorized';
    return cat === 'Uncategorized' || txn.category_source === 'none';
}

/** Uncategorized + guesses — review queue on Spend */
export function isReviewTxn(txn) {
    return isUncategorizedTxn(txn) || isGuessTxn(txn);
}

/** Person-like / P2P guess → offer People vs Shop quick pick */
export function isAmbiguousPeopleGuess(txn) {
    if (!isGuessTxn(txn)) return false;
    if (txn.category_source === 'amount_heuristic') return true;
    if (txn.category === 'Family & Friends') return true;
    return false;
}

export const REVIEW_FILTER = '__review__';
